<div class="modal-content">
    <h4 class="modal-title kx-modal-heading pl-2">
        <strong>End Call</strong>
    </h4>

    <div class="modal-body">
        <ng-container>
            <div class="text-bold m-3 row">You Left the consultation</div>
            <div class="row">
                <div class="col-6">
                    <button class="primary-btn btn-lg" (click)="rejoin()">Rejoin Video Consultation</button>
                </div>
                <div class="col-6 ">
                    <button class="primary-btn btn-lg float-right" (click)="endCall()">End Consultation</button>
                </div>
            </div>
        </ng-container>
    </div>
</div>